import { useState } from 'react';
import { useSnackbar } from 'notistack';
import { AxiosError } from 'axios';
import { closeRealEstateEvent } from '../api';

function useCloseRealEstateEvent(realEstateEventId: number, onClose?: () => void) {
  const { enqueueSnackbar } = useSnackbar();

  const [state, setState] = useState<{ loading: boolean; error: string | null }>({ loading: false, error: null });

  async function handleCloseEvent() {
    try {
      setState({ loading: true, error: null });

      await closeRealEstateEvent(realEstateEventId);

      if (onClose) onClose();
    } catch (error) {
      const message = (error as AxiosError).response?.data.message;

      setState({ loading: false, error: message });
      enqueueSnackbar(message, { variant: 'error' });
    } finally {
      setState((prevState) => ({ ...prevState, loading: false }));
    }
  }

  return { handleCloseEvent, closeEventState: state };
}

export default useCloseRealEstateEvent;
